import React from 'react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { TableSports } from 'src/domains/sportsbook/webview/components/meetings/tableSports/TableSports';
import { observer } from 'src/utils/mobx-react';
import { SportRacesTypeParamType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { MeetingsGroupWrapper } from './Meetings.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export type TableSportsSectionType = Extract<SportRacesTypeParamType, 'ante-post' | 'specials'>;

interface TableSportsListPropsType {
    events: Record<string, Array<EventModel>>;
    section: TableSportsSectionType;
    handleScroll?: () => void;
}

export const TableSportsList = observer(
    'TableSportsList',
    ({ section, events, handleScroll }: TableSportsListPropsType): JSX.Element => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        return (
            <MeetingsGroupWrapper variant={configState.componentVariants.sportsbookVariant}>
                {Object.keys(events).map((month) => (
                    <TableSports
                        dataTest='ante-post-events'
                        events={events}
                        handleScroll={handleScroll}
                        key={month}
                        month={month}
                        section={section}
                    />
                ))}
            </MeetingsGroupWrapper>
        );
    }
);
